import React from 'react';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '../ui/alert-dialog';

export const DeleteConfirmModal = ({ open, onOpenChange, onConfirm, entryTitle }) => {
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent className="bg-[#0A0A0A] border-white/10">
                <AlertDialogHeader>
                    <AlertDialogTitle className="font-['Rajdhani'] text-xl text-white">
                        Delete Entry
                    </AlertDialogTitle>
                    <AlertDialogDescription className="text-gray-400">
                        Are you sure you want to delete this entry?
                        {entryTitle && (
                            <span className="block mt-2 text-white font-medium">
                                "{entryTitle}"
                            </span>
                        )}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter className="gap-2">
                    <AlertDialogCancel 
                        data-testid="cancel-delete-button"
                        className="bg-transparent border-white/10 text-gray-400 hover:bg-white/5 hover:text-white"
                    >
                        Cancel
                    </AlertDialogCancel>
                    <AlertDialogAction
                        data-testid="confirm-delete-button"
                        onClick={onConfirm}
                        className="bg-red-500/10 text-red-400 border border-red-500/20 hover:bg-red-500/20"
                    >
                        Yes
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};
